import {
    SET_MY_COVERAGE_DATA
} from './types';

const reducers = (state: any = {}, action: any) => {
    if (action.type == SET_MY_COVERAGE_DATA) {
        state = JSON.parse(JSON.stringify(action.myCoverageData));;
        return {
            ...state
        };
    } else {
        return state;
    }
};

export default reducers;